import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0016',
    ecrans: ['00-2'],
    params: ['?rbucleintpar',
             '?unocleintpar']
});
